export default __webpack_public_path__ + "static/media/logo_fix_knowbe_logo-wh.68875d64.png";